import {observable, action} from 'mobx';
import _ from 'lodash';

class ClinicalNoteWritingCategoriesStore {

  @observable categories = [];
  @observable category = _.assign({}, {
    id: 0,
    title: '',
  });
  @observable errors = {};

  @action
  setCategories = categories => {
    this.categories = categories;
  };

  @action
  initNewCategory = () => {
   this.category = _.assign({}, {
      id: 0,
      title: '',
    });
  };

  @action
  setError = errors => {
    this.errors = errors;
  };

  @action
  setCategory = category => {
    this.category = category;
  };

  @action
  updateCategory = category => {
    const allCategories = [...this.categories];
    let oldCategoryIndex = allCategories.findIndex(e => e.id === category.id);
    allCategories[oldCategoryIndex] = category;
    this.setCategories(allCategories); 
  }

  @action
  saveCategory = category => {
    const allCategories = [...this.categories];
    allCategories.push(category);
    this.setCategories(allCategories); 
  }

  getCategoryById = id => {
    return this.categories.find(el => el.id === id);
  };

  @action
  handleUpdateCategory = newCategory => {
    let oldCategory = this.getCategoryById(newCategory.id);
    _.assign(oldCategory, newCategory);
  };

  @action
  createCategory = category => {
    this.categories.unshift(category);
  };

  @action
  deleteCategory = id => {
    const allCategories = [...this.categories];
    let index = _.findIndex(allCategories, el => el.id === id);
    allCategories.splice(index, 1);
    this.setCategories(allCategories);
  };

  @action
  sortCategories = categories => {
    return categories.sort((category_a, category_b) => category_a.title.localeCompare(category_b.title));
  }

  @action
  handleChange = data => {
    _.assign(this.category, data);
  }
}

export default new ClinicalNoteWritingCategoriesStore();



// WEBPACK FOOTER //
// ./src/stores/ClinicalNoteWritingCategoriesStore.js